export const atLeastOneLowercaseCharacterRegex = /(?=.*[a-z])/
export const atLeastOneUppercaseCharacterRegex = /(?=.*[A-Z])/
export const atLeastOneNumberRegex = /(?=.*\d)/
export const integerNumbersRegex = /^\d+$/
export const numbersRegex = /^[0-9]+([.][0-9]+)?$/
export const numbersLettersRegex = /^[A-Za-z0-9]+$/
export const numbersLettersSpaceRegex = /^[A-Za-z0-9\s]+$/
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
